// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EAxU","input":"styles_input__3t5Cd"};